<!-- eslint-disable max-len -->
<template>
  <div class="component-card">
    <i
      v-if="!readOnly"
      id="popoverChangePasswd"
      class="fa fa-2x fa-ellipsis-v pull-right cursor-pointer"
      @click="showModal = true"/>
    <j-title-header :options="title"/>

    <!-- <j-tabs :tabs="tabs">
      <div class="tab-content">
        <div
          v-for="i in tabs"
          :key="i.id"
          :id="i.idComp"
          :aria-labelledby="i.idTab"
          role="tabpanel"
          class="tab-pane" >
          <component :is="i.comp.name"/>
        </div>
      </div>
    </j-tabs> -->

    <b-row>
      <b-col md="3">
        <div class="menu-pegawai">
          <h4>Menu</h4>
          <div
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ 'active': menu_active === item.title }"
            class="col-12 d-flex justify-content-between component-card-form cursor-pointer align-items-end"
            @click="setActiveMenu(item.title)">
            <div class="d-flex align-items-center">
              <!-- <img
                :src="require('@/assets/image/detail.png')"
                width="20"
                class="m__r--10"> -->
              <div class="title-form-component">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="9">
        <j-general v-if="menu_active === 'General'" />
        <j-role v-if="menu_active === 'Role'" />
        <j-sertifikasi v-if="menu_active === 'Sertifikasi'" />
        <j-pendidikan v-if="menu_active === 'Pendidikan'" />
        <j-kompetensi v-if="menu_active === 'Kompetensi'" />
        <j-anak v-if="menu_active === 'Anak'" />
        <j-beasiswa v-if="menu_active === 'Beasiswa'" />
        <j-buku v-if="menu_active === 'Buku'" />
        <j-diklat v-if="menu_active === 'Diklat'" />
        <j-karya-tulis v-if="menu_active === 'Karya Tulis'" />
        <j-kesejahteraan v-if="menu_active === 'Kesejahteraan'" />
        <j-tunjangan v-if="menu_active === 'Tunjangan'" />
        <j-tugas-tambahan v-if="menu_active === 'Tugas Tambahan'" />
        <j-inpassing-non-pns v-if="menu_active === 'Inpassing Non PNS'" />
        <j-penghargaan v-if="menu_active === 'Penghargaan'" />
        <j-nilai-tes v-if="menu_active === 'Nilai Tes'" />
        <j-gaji-berkala v-if="menu_active === 'Riwayat Gaji Berkala'" />
        <j-karir-guru v-if="menu_active === 'Riwayat Karir Guru'" />
        <j-jabatan-pendidik v-if="menu_active === 'Riwayat Jabatan Pendidik'" />
        <j-golongan v-if="menu_active === 'Riwayat Golongan'" />
        <j-jabatan-fungsional v-if="menu_active === 'Riwayat Jabatan Fungsional'" />
      </b-col>
    </b-row>

    <b-popover
      ref="changePasswdModal"
      :show.sync="popoverChangePasswdShow"
      target="popoverChangePasswd"
      placement="left">
      <div
        class="cursor-pointer"
        @click="createData">Change Password</div>
      <div
        class="m__b--10 cursor-pointer"
        @click="deleteData">Delete</div>
    </b-popover>

    <b-modal
      v-if="showModal"
      ref="modalChangePasswd"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">CHANGE PASSWORD</h2>

      <b-form-group :class="{'error-input' : $v.data_master.password.$error}">
        <label> Password </label>
        <j-input
          v-model="$v.data_master.password.$model"
          :type="password"
          :error-required="$v.data_master.password.$error"
          placeholder="Type New Password"/>
      </b-form-group>
      <b-form-checkbox v-model="show_pass">show password</b-form-checkbox><br><br>

      <b-form-group :class="{'error-input' : $v.data_master.confirm_password.$error || data_master.password !== data_master.confirm_password}">
        <label> Confirm Password </label>
        <j-input
          v-model="$v.data_master.confirm_password.$model"
          :error-message="'Password dan Confirm Password harus sama'"
          :error-required="$v.data_master.password.$error || data_master.password !== data_master.confirm_password"
          :type="confirm_password"
          placeholder="Type Confirm Password"/>
      </b-form-group>
      <b-form-checkbox v-model="show_conpass">show password</b-form-checkbox>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn gray m__r--5"
          @click="closeModal">
          Cancel
        </b-button>
        <b-button
          class="btn blue"
          @click="saveData">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jGeneral from '@/views/kurikulum/kepegawaian/tab-component/jGeneral';
import jSertifikasi from '@/views/kurikulum/kepegawaian/tab-component/jSertifikasi';
import jPendidikan from '@/views/kurikulum/kepegawaian/tab-component/jPendidikan';
import jKompetensi from '@/views/kurikulum/kepegawaian/tab-component/jKompetensi';
import jAnak from '@/views/kurikulum/kepegawaian/tab-component/jAnak';
import jBeasiswa from '@/views/kurikulum/kepegawaian/tab-component/jBeasiswa';
import jBuku from '@/views/kurikulum/kepegawaian/tab-component/jBuku';
import jDiklat from '@/views/kurikulum/kepegawaian/tab-component/jDiklat';
import jKaryaTulis from '@/views/kurikulum/kepegawaian/tab-component/jKaryaTulis';
import jKesejahteraan from '@/views/kurikulum/kepegawaian/tab-component/jKesejahteraan';
import jTunjangan from '@/views/kurikulum/kepegawaian/tab-component/jTunjangan';
import jTugasTambahan from '@/views/kurikulum/kepegawaian/tab-component/jTugasTambahan';
import jInpassingNonPns from '@/views/kurikulum/kepegawaian/tab-component/jInpassingNonPns';
import jPenghargaan from '@/views/kurikulum/kepegawaian/tab-component/jPenghargaan';
import jNilaiTes from '@/views/kurikulum/kepegawaian/tab-component/jNilaiTes';
import jGajiBerkala from '@/views/kurikulum/kepegawaian/tab-component/jGajiBerkala';
import jJabatanPendidik from '@/views/kurikulum/kepegawaian/tab-component/jJabatanPendidik';
import jGolongan from '@/views/kurikulum/kepegawaian/tab-component/jGolongan';
import jJabatanFungsional from '@/views/kurikulum/kepegawaian/tab-component/jJabatanFungsional';
import jKarirGuru from '@/views/kurikulum/kepegawaian/tab-component/jKarirGuru';
import jRole from '@/views/kurikulum/kepegawaian/tab-component/jRole';
import jBlank from '@/views/kurikulum/kepegawaian/tab-component/jBlank';

export default {
  components: {
    jGeneral,
    jSertifikasi,
    jPendidikan,
    jKompetensi,
    jAnak,
    jBeasiswa,
    jBuku,
    jDiklat,
    jKaryaTulis,
    jKesejahteraan,
    jTunjangan,
    jTugasTambahan,
    jInpassingNonPns,
    jPenghargaan,
    jNilaiTes,
    jGajiBerkala,
    jJabatanPendidik,
    jGolongan,
    jJabatanFungsional,
    jKarirGuru,
    jRole,
    jBlank,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Update Data Pegawai',
      },
      popoverChangePasswdShow: false,
      showModal: false,
      data_master: {
        password: '',
        confirm_password: '',
      },
      show_pass: false,
      show_conpass: false,
      menu_active: 'General',
      tabs: [
        {
          idTab: 'tab-general', title: 'General', idComp: 'comp-general', comp: jGeneral, isShow: true,
        },
        {
          idTab: 'tab-role', title: 'Role', idComp: 'comp-role', comp: jRole, isShow: !this.$route.params.module,
        },
        {
          idTab: 'tab-sertifikasi', title: 'Sertifikasi', idComp: 'comp-sertifikasi', comp: jSertifikasi, isShow: true,
        },
        {
          idTab: 'tab-pendidikan', title: 'Pendidikan', idComp: 'comp-pendidikan', comp: jPendidikan, isShow: true,
        },
        {
          idTab: 'tab-kompetensi', title: 'Kompetensi', idComp: 'comp-kompetensi', comp: jKompetensi, isShow: true,
        },
        {
          idTab: 'tab-anak', title: 'Anak', idComp: 'comp-anak', comp: jAnak, isShow: true,
        },
        {
          idTab: 'tab-beasiswa', title: 'Beasiswa', idComp: 'comp-beasiswa', comp: jBeasiswa, isShow: true,
        },
        {
          idTab: 'tab-buku', title: 'Buku', idComp: 'comp-buku', comp: jBuku, isShow: true,
        },
        {
          idTab: 'tab-diklat', title: 'Diklat', idComp: 'comp-diklat', comp: jDiklat, isShow: true,
        },
        {
          idTab: 'tab-karyatulis', title: 'Karya Tulis', idComp: 'comp-karyatulis', comp: jKaryaTulis, isShow: true,
        },
        {
          idTab: 'tab-kesejahteraan', title: 'Kesejahteraan', idComp: 'comp-kesejahteraan', comp: jKesejahteraan, isShow: true,
        },
        {
          idTab: 'tab-tunjangan', title: 'Tunjangan', idComp: 'comp-tunjangan', comp: jTunjangan, isShow: true,
        },
        {
          idTab: 'tab-tugas-tambahan', title: 'Tugas Tambahan', idComp: 'comp-tugas-tambahan', comp: jTugasTambahan, isShow: true,
        },
        {
          idTab: 'tab-inpasing', title: 'Inpassing Non PNS', idComp: 'comp-inpasing', comp: jInpassingNonPns, isShow: true,
        },
        {
          idTab: 'tab-penghargaan', title: 'Penghargaan', idComp: 'comp-penghargaan', comp: jPenghargaan, isShow: true,
        },
        {
          idTab: 'tab-nilai-tes', title: 'Nilai Tes', idComp: 'comp-nilai-tes', comp: jNilaiTes, isShow: true,
        },
        {
          idTab: 'tab-riwayat-gaji', title: 'Riwayat Gaji Berkala', idComp: 'comp-riwayat-gaji', comp: jGajiBerkala, isShow: true,
        },
        {
          idTab: 'tab-riwayat-karir', title: 'Riwayat Karir Guru', idComp: 'comp-riwayat-karir', comp: jKarirGuru, isShow: true,
        },
        {
          idTab: 'tab-riwayat-jabatan', title: 'Riwayat Jabatan Pendidik', idComp: 'comp-riwayat-jabatab', comp: jJabatanPendidik, isShow: true,
        },
        {
          idTab: 'tab-riwayat-golongan', title: 'Riwayat Golongan', idComp: 'comp-riwayat-golongan', comp: jGolongan, isShow: true,
        },
        {
          idTab: 'tab-riwayat-jabatan-fungsional', title: 'Riwayat Jabatan Fungsional', idComp: 'comp-riwayat-jabatan-fungsional', comp: jJabatanFungsional, isShow: true,
        },
      ],
    };
  },
  computed: {
    password() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },

    confirm_password() {
      if (this.show_conpass) {
        return 'text';
      }
      return 'password';
    },
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['changePasswdPegawai', 'deletePegawai']),

    setActiveMenu(name) {
      this.menu_active = name;
    },

    createData() {
      this.popoverChangePasswdShow = false;
      this.$refs.modalChangePasswd.show();
    },

    closeModal() {
      this.$refs.modalChangePasswd.hide();
      this.data_master = {
        password: '',
        confirm_password: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const param = {
          id: this.$route.params.id,
          password: this.data_master.password,
        };
        this.changePasswdPegawai(param).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.closeModal();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.popoverChangePasswdShow = false;
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.$route.params.id,
          };
          this.deletePegawai(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/kepegawaian');
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        password: { required },
        confirm_password: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/jKepegawaianUpdate.vue